import { Dialog } from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import "./AppAuthSetup.scss";
import CloseIcon from "@mui/icons-material/Close";
import {
  getAppAuthSecret,
  sendOtpService,
  verifyAndSetAppAuth,
} from "../../services/authService";
import OtpInput from "react-otp-input";
import { toastMessage } from "../../helper";
import { useDispatch, useSelector } from "react-redux";
import { USER_REDUCER } from "../../constants/enums";
import { resendRegisterOTP, verifyOTPAuth } from "../../actions/authActions";

const AppAuthSetup = (props: any) => {
  const { open, onClose, email, fromLogin, isEdit } = props;
  const dispatch = useDispatch();
  const userDetails = useSelector((state: any) => state.user.userDetails);
  const [step, setStep] = useState("info");
  const [QRSrc, setQRSrc] = useState("");
  const [appOtp, setAppOtp] = useState("");
  const [emailOtp, setEmailOtp] = useState("");

  const generateQR = (userName: string) => {
    userName?.length &&
      getAppAuthSecret(userName.toLocaleLowerCase()).then((res) => {
        res?.data?.qrCode && setQRSrc(res.data.qrCode);
        setStep("showQR");
      });
  };
  const handleClose = () => {
    onClose({ type: "appAuthSetup" });
  };

  const handleNext = () => {
    if (step === "info") {
      const userName = email.toLocaleLowerCase();
      if (localStorage.getItem("token") && !fromLogin) {
        generateQR(userName);
      } else {
        sendOtpService({ email: userName }, false)
          .then(() => {
            setStep("verifyOTP");
          })
          .catch((err: any) => {
            toastMessage(err.response.data.message, "error");
            console.log(
              "Error:",
              err.response && err.response.data && err.response.data.message
            );
          });
      }
    }
  };

  const onAppOTPChange = async (value: string) => {
    setAppOtp(value);
    if (value.length === 6) {
      const userName = email.toLocaleLowerCase();
      verifyAndSetAppAuth({ userName, otp: value })
        .then((res: any) => {
          if (res?.data?.setupCompleted) {
            dispatch({
              type: USER_REDUCER.SET_USER_DETAILS,
              payload: { ...userDetails, appAuthSetup: true },
            });
            toastMessage("Setup completed.", "success");
            handleClose();
          }
        })
        .catch((err: any) => {
          toastMessage(err.response.data.message, "error");
          console.log(
            "Error:",
            err.response && err.response.data && err.response.data.message
          );
        });
    }
  };

  const onEmailOTPChange = async (value: string) => {
    setEmailOtp(value);
    if (value.length === 6) {
      const userName = email.toLocaleLowerCase();
      verifyOTPAuth(userName, value, {}, "emailAuth", false)
        .then((res: any) => {
          console.log(res);
          if (res?.data?.otpVerified) {
            generateQR(userName);
          }
        })
        .catch((err: any) => {
          toastMessage(err.response.data.message, "error");
          console.log(
            "Error:",
            err.response && err.response.data && err.response.data.message
          );
        });
    }
  };

  return (
    <Fragment>
      <div>
        <Dialog className="pw-dialog-app-auth" open={open}>
          <div className=" bg-gray-50 shadow flex-col justify-start items-center inline-flex">
            <div className="mt-12 px-12 self-stretch h-auto flex-col justify-center items-start gap-2 flex">
              <div className="self-stretch justify-between items-start inline-flex">
                <div className="w-96 h-8 text-neutral-800 text-2xl font-bold font-['Proxima Nova']">
                  2FA using app-based TOTP
                </div>
                <div className="cursor-pointer" onClick={handleClose}>
                  <CloseIcon className="pw-color-close-attchments" />
                </div>
              </div>
              {step === "info" ? (
                <div className="h-auto text-neutral-700 text-sm font-normal font-['Proxima Nova'] leading-tight mt-2">
                  Use authenticator apps and browser extensions like Google
                  Authenticator, 1Password, Authy, Microsoft Authenticator, etc.
                  to generate time-based one-time passwords that are used as a
                  second factor to verify your identity when prompted during
                  sign-in.
                </div>
              ) : step === "verifyOTP" ? (
                <div className="flex flex-col pw-overflow-y-auto w-full">
                  <div className="h-auto text-neutral-700 text-sm font-normal font-['Proxima Nova'] leading-tight mt-2">
                    Enter OTP Sent to Registered Mail
                  </div>
                  <OtpInput
                    value={emailOtp}
                    onChange={onEmailOTPChange}
                    numInputs={6}
                    isInputNum={true}
                    className={"pw-border w-100v"}
                    separator={<span>&nbsp;</span>}
                    inputStyle={{
                      backgroundColor: "#fafbfd",
                    }}
                  />
                </div>
              ) : (
                <div className="h-auto w-full text-neutral-700 text-sm font-normal font-['Proxima Nova'] leading-tight mt-2 flex-col justify-center items-start">
                  <div>Scan the QR code on your authenticator app.</div>
                  <div className="w-full flex flex-row justify-center items-center py-6">
                    {QRSrc?.length && (
                      <img src={"data:image/png;base64," + QRSrc} />
                    )}
                  </div>
                  <div>
                    Once scanned, the app should give you a 6 digit TOTP. Enter
                    it here.
                  </div>
                  <div className="w-80 mt-4">
                    <OtpInput
                      value={appOtp}
                      onChange={onAppOTPChange}
                      numInputs={6}
                      isInputNum={true}
                      className={"pw-border w-100v"}
                      separator={<span>&nbsp;</span>}
                      inputStyle={{
                        backgroundColor: "#fafbfd",
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="self-stretch pw-bottom-box-shadow h-px border border-zinc-200 mt-12"></div>
            <div className="self-stretch bg-white py-3 px-8 flex flex-row-reverse gap-4">
              <div
                onClick={handleNext}
                className="pw-app-auth-add-new text-neutral bg-white font-bold"
              >
                {step === "info" || step === "verifyOTP"
                  ? isEdit
                    ? "Edit 2FA with TOTP"
                    : "Setup 2FA with TOTP"
                  : "Finish"}
              </div>
              <div
                className="pw-app-auth-cancel text-neutral bg-white font-bold"
                onClick={handleClose}
              >
                Cancel
              </div>
            </div>
          </div>
        </Dialog>
      </div>
    </Fragment>
  );
};

export default AppAuthSetup;
